module.exports = __webpack_public_path__ + "static/media/background_count.fc5c9bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background_count.png
// module id = 614
// module chunks = 0